import React from "react";

export const IframeContext = React.createContext<{
  isIframe: boolean;
}>({ isIframe: false });

export const useIframe = () => React.useContext(IframeContext);
